import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { getAllDoctors } from "../../actions/doctorActions";
import { getAllUsers, updateUser } from "src/actions/loginAction";
import { listAllInvoices } from "../../actions/invoiceActions"; // <-- 1. IMPORT
import { imgUrl } from "src/actions/types";
import MessageModal from "../Pages/MessageModel";
import { formatCurrency } from "../utils/currencyHelper";
// --- Helper function to format currency ---
// const formatCurrency = (amount) => {
//   return new Intl.NumberFormat("en-IN", {
//     style: "currency",
//     currency: "INR",
//     maximumFractionDigits: 0,
//   }).format(amount || 0);
// };

const DoctorList = (props) => {
  const {
    doctors,
    loading,
    error,
    userList,
    invoices, // <-- 2. GET FROM PROPS
    getAllDoctors,
    getAllUsers,
    updateUser,
    selectedCurrency, 
    listAllInvoices, // <-- 2. GET FROM PROPS
  } = props;

  const [localDoctors, setLocalDoctors] = useState([]);
  const [modalState, setModalState] = useState({
    show: false,
    title: "",
    message: "",
    variant: "info",
  });

  useEffect(() => {
    getAllDoctors();
    getAllUsers();
    listAllInvoices(); // <-- 3. FETCH INVOICES
  }, [getAllDoctors, getAllUsers, listAllInvoices]);

  // --- (MODIFIED) This effect now calculates earnings from INVOICES ---
  useEffect(() => {
    if (
      doctors &&
      Array.isArray(doctors) &&
      !loading &&
      Array.isArray(userList) &&
      Array.isArray(invoices)
    ) {
      // Calculate total earnings for each doctor from PAID invoices
      const earningsMap = new Map();
      invoices.forEach((inv) => {
        // The crucial business rule: only count if status is 'Paid'
        if (inv.Status && inv.Status.toLowerCase() === "paid") {
          const doctorId = inv.hospitalID;
          const amount = parseFloat(inv.TotalAmount) || 0;
          const currentEarnings = earningsMap.get(doctorId) || 0;
          earningsMap.set(doctorId, currentEarnings + amount);
        }
      });

      const mergedAndSanitizedDoctors = doctors.map((doc) => {
        const matchedUser = userList.find(
          (user) => user.hospitalID === doc.hospitalID
        );

        let memberSinceDate = "N/A";
        let memberSinceTime = "";
        let accountStatus = false;
        let userEmail = null;

        if (matchedUser) {
          userEmail = matchedUser.email;
          accountStatus = matchedUser.app_status === "enabled";
          if (matchedUser.created_at) {
            const createdDate = new Date(matchedUser.created_at);
            memberSinceDate = createdDate.toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            });
            memberSinceTime = createdDate.toLocaleTimeString("en-US", {
              hour: "numeric",
              minute: "2-digit",
              hour12: true,
            });
          }
        }

        return {
          ...doc,
          AccountStatus: accountStatus,
          MemberSinceDate: memberSinceDate,
          MemberSinceTime: memberSinceTime,
          userEmail: userEmail,
          earned: earningsMap.get(doc.hospitalID) || 0, // <-- Add calculated earnings
        };
      });

      setLocalDoctors(mergedAndSanitizedDoctors);
    }
  }, [doctors, loading, userList, invoices]); // <-- Add invoices to dependency array

  // const handleStatusToggle = async (doctor, index) => {
  //   const updatedStatusBoolean = !doctor.AccountStatus;
  //   const updatedDoctors = [...localDoctors];
  //   updatedDoctors[index].AccountStatus = updatedStatusBoolean;
  //   setLocalDoctors(updatedDoctors);

  //   try {
  //     if (!doctor.userEmail) {
  //       throw new Error(
  //         "Cannot update status: Doctor's associated user email not found."
  //       );
  //     }

  //     const updatedStatusString = updatedStatusBoolean ? "enabled" : "disabled";
  //     const userUpdatePayload = {
  //       email: doctor.userEmail,
  //       hospitalID: doctor.hospitalID,
  //       app_status: updatedStatusString,
  //     };
  //     await updateUser(userUpdatePayload);

  //     setModalState({
  //       show: true,
  //       title: "Success",
  //       message: "Account status updated successfully!",
  //       variant: "success",
  //     });

  //     getAllUsers();
  //     getAllDoctors();
  //   } catch (error) {
  //     setModalState({
  //       show: true,
  //       title: "Error",
  //       message: `Failed to update account status. ${error.message || ""}`,
  //       variant: "danger",
  //     });
  //     updatedDoctors[index].AccountStatus = !updatedStatusBoolean;
  //     setLocalDoctors(updatedDoctors);
  //   }
  // };
const handleStatusToggle = async (doctor, index) => {
 
  const targetUser = userList.find(
    (u) => u.hospitalID === doctor.hospitalID
  );

  if (!targetUser) {
    setModalState({
      show: true,
      title: "Error",
      message: "User not found in data.",
      variant: "danger",
    });
    return;
  }


  const newAccountStatus = !doctor.AccountStatus; 
  const newAppStatusString = newAccountStatus ? "enabled" : "disabled";

 
  const updatedDoctors = [...localDoctors];
  updatedDoctors[index].AccountStatus = newAccountStatus;
  setLocalDoctors(updatedDoctors);

  try {
    
    const userUpdatePayload = {
      hospitalID: targetUser.hospitalID,
      username: targetUser.username,
      password: targetUser.password, 
      first_name: targetUser.first_name,
      last_name: targetUser.last_name,
      email: targetUser.email,
      role: targetUser.role,
      subscription_status: targetUser.subscription_status,
      mobile: targetUser.mobile,
      app_status: newAppStatusString, 
      created_at: targetUser.created_at,
      Subscription_type: targetUser.Subscription_type
    };

    
    await updateUser(userUpdatePayload);

    setModalState({
      show: true,
      title: "Success",
      message: `Status updated to ${newAppStatusString} successfully!`,
      variant: "success",
    });

   
    getAllUsers();
    getAllDoctors();
  } catch (error) {
    setModalState({
      show: true,
      title: "Error",
      message: `Failed to update status: ${error.message || ""}`,
      variant: "danger",
    });
   
    updatedDoctors[index].AccountStatus = !newAccountStatus;
    setLocalDoctors(updatedDoctors);
  }
};
  return (
    <>
      <MessageModal
        show={modalState.show}
        onClose={() => setModalState({ ...modalState, show: false })}
        title={modalState.title}
        message={modalState.message}
        variant={modalState.variant}
      />

      <div className="page-wrapper ml-0">
        <div className="content-container">
          {/* Page Header */}
          <div className="page-header filter-bar rounded">
            <div className="row align-items-center">
              <div className="col">
                <h4 className="page-title"> Doctors-List</h4>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/doctor/dashboard">Admin Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Doctor-List</li>
                </ul>
              </div>
            </div>
          </div>
          {loading ? (
            <div className="text-center p-5">
              <div className="spinner-border text-primary" role="status"></div>
            </div>
          ) : error ? (
            <p className="text-danger">{error}</p>
          ) : (
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-hover table-center mb-0 datatable">
                        <thead>
                          <tr>
                            <th>Doctor Name</th>
                            <th>Doctor Mobile</th>
                            <th>Speciality</th>
                            <th>Member Since</th>
                            <th>Earned</th>
                            <th>Account Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {localDoctors.map((doctor, index) => (
                            <tr key={doctor.id || index}>
                              <td>
                                <h2 className="table-avatar">
                                  <span className="avatar avatar-sm mr-2">
                                    <img
                                      className="avatar-img rounded-circle"
                                      src={
                                        doctor.uploadPhoto
                                          ? `${imgUrl}${doctor.uploadPhoto}`
                                          : "/assets/img/defaultDoctorProfile.jpg"
                                      }
                                      alt="Doctor"
                                    />
                                  </span>
                                  <strong>
                                    Dr. {doctor.firstName} {doctor.lastName}
                                    <span className="d-block text-muted">
                                      #{doctor.hospitalID}
                                    </span>
                                  </strong>
                                </h2>
                              </td>
                              <td>
                                {doctor.phoneNumber &&
                                doctor.phoneNumber.length > 0
                                  ? doctor.phoneNumber
                                  : "N/A"}
                              </td>
                              <td>
                                {doctor.Specializations &&
                                doctor.Specializations.length > 0
                                  ? doctor.Specializations.map(
                                      (s) => s.Specialization
                                    ).join(", ")
                                  : "N/A"}
                              </td>
                              <td>
                                {doctor.MemberSinceDate}
                                <br />
                                <span className="text-muted">
                                  {doctor.MemberSinceTime}
                                </span>
                              </td>
                              {/* --- Display formatted dynamic earnings --- */}
                              <td className="text-success font-weight-bold">
  {formatCurrency(doctor.earned, selectedCurrency)}
</td>
                              <td>
                                <div>
                                  <input
                                    type="checkbox"
                                    id={`status_${index}`}
                                    className="check"
                                    checked={doctor.AccountStatus === true}
                                    onChange={() =>
                                      handleStatusToggle(doctor, index)
                                    }
                                  />
                                  <label
                                    htmlFor={`status_${index}`}
                                    className="checktoggle"
                                  >
                                    checkbox
                                  </label>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

// --- (MODIFIED) Add invoices to Redux state mapping ---
const mapStateToProps = (state) => ({
  doctors: state.doctorList?.doctors || [],
  loading: state.doctorList?.loading || state.invoice?.loading,
  error: state.doctorList?.error || state.invoice?.error,
  selectedCurrency: state.currencyReducer.selectedCurrency,
  userList: Array.isArray(state.loginReducer?.userList?.data)
    ? state.loginReducer.userList.data
    : [],
  invoices: state.invoice?.invoices || [], // <-- Get invoices
});

// --- (MODIFIED) Add listAllInvoices to Redux actions ---
export default connect(mapStateToProps, {
  getAllDoctors,
  getAllUsers,
  updateUser,
  listAllInvoices, // <-- Connect action
})(DoctorList);
